import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { DataSourceIntegrationKey } from 'const/dataSourceIntegrations'
import { getPath } from 'routing/pagePaths'

interface DataSourceIntegrationInfo {
    key: DataSourceIntegrationKey
    name: string
    url: string
}

export function useDataSourceIntegrationInfo(): Record<
    DataSourceIntegrationKey,
    DataSourceIntegrationInfo
> {
    const { t } = useTranslation()
    return useMemo(
        () => ({
            amazon_advertising: {
                key: 'amazon_advertising',
                name: t(
                    'common:data.integrations.amazon_advertising',
                    'Amazon Advertising'
                ),
                url: `${getPath('settingsPage')}/amazon-integrations`,
            },
            amazon_advertising_dsp: {
                key: 'amazon_advertising_dsp',
                name: t(
                    'common:data.integrations.amazon_advertising_dsp',
                    'Amazon Advertising Agency'
                ),
                url: `${getPath('settingsPage')}/amazon-integrations`,
            },
            seller_central: {
                key: 'seller_central',
                name: t(
                    'common:data.integrations.seller_central',
                    'Selling Partner'
                ),
                url: `${getPath('settingsPage')}/amazon-integrations?tab=selling-partner`,
            },
            vendor_central: {
                key: 'vendor_central',
                name: t(
                    'common:data.integrations.vendor_central',
                    'Selling Partner'
                ),
                url: `${getPath('settingsPage')}/amazon-integrations?tab=vendor-central`,
            },
        }),
        [t]
    )
}
